import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, references } from '@apexdesigner/schema-tools';

export const alternateStudentAvailability = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    slotId: z.number().presentAs('reference').describe('Foreign key to Slot'),

    alternateStudentId: z
      .number()
      .hidden()
      .describe('Foreign key to AlternateStudent'),

    slot: references('Slot'),

    alternateStudent: belongsTo('AlternateStudent'),
  })
  .describe('A per-slot availability record for an alternate student.')
  .as('AlternateStudentAvailability');

export { alternateStudentAvailability as alternateStudentAvailabilitySchema };
